import AchievementsBlock from './AchievementsBlock';

export default AchievementsBlock;
